"use client";

import { metaPro } from "@/assets/fonts/fonts";
import getBuilderLocalizedValue from "@/i18n/get-builder-localized-value";
import { useLocale } from "@/libs/base/components/locale-provider";
import dynamic from "next/dynamic";

const Marquee = dynamic(() => import("react-fast-marquee"), { ssr: false });

interface ComponentProps {
  text: BuilderLocalizedValue | string;
  speed: number;
  direction: "left" | "right";
  pauseOnHover: boolean;
}

export default function MarqueeText(props: ComponentProps) {
  const locale = useLocale();
  const text = typeof props.text === "string" ? props.text : getBuilderLocalizedValue(props.text, locale);

  return (
    <div className="text-[164px] leading-none">
      <Marquee
        speed={props.speed}
        direction={props.direction}
        pauseOnHover={props.pauseOnHover}
        autoFill={true}
        className="overflow-hidden whitespace-nowrap pb-2"
      >
        <pre className={metaPro.className}>{text}</pre>
      </Marquee>
    </div>
  );
}
